import {
  PageHeader,
  Row,
  Col,
  Menu,
  Input,
  Card,
  Collapse,
  Empty,
  Spin,
  List,
  Tooltip,
  Tag,
  message,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  SearchOutlined,
  SafetyCertificateOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  InputItem,
  ButtonItem,
} from "../../../Components/Items";
import ModalPermisos from "./ModalPermisos/ModalPermisos";
import ModalEliminar from "./ModalEliminar/ModalEliminar";
import { labelDesdeFuenteOpciones } from "./fuentesOpciones";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const { Panel } = Collapse;

const TIPO_TAG = {
  boolean: { color: "default", label: "Booleano" },
  monto: { color: "gold", label: "Monto" },
  seleccion: { color: "geekblue", label: "Selección" },
};


class Permisos extends Component {
  formRefModal = React.createRef();
  state = {
    loading: false,
    // Datos
    grupos: [],
    subGruposActivos: [], // Subgrupos y sus permisos del grupo seleccionado
    grupoActivo: null,

    // Buscadores
    busquedaGrupo: "",
    busquedaSubGrupo: "",

    // Modal de crear / editar
    modalVisible: false,
    tipoModal: "", // 'grupo', 'subgrupo', 'permiso'
    itemEditandoId: null,
    subGrupoDestinoId: null,

    // Modal de eliminar
    modalEliminarVisible: false,
    tipoEliminar: "", // 'grupo', 'subgrupo', 'permiso'
    itemEliminarId: null,
  };

  componentDidMount() {
    this.consultarGrupos();
  }

  async consultarGrupos() {
    this.setState({ loading: true });

    await axios
      .post("permisos/selectGrupos", {}, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ grupos: res.data.grupos || [] });
        }
      })
      .catch((error) => {
        console.log(error);
        message.error("Este usuario no tiene acceso a los permisos");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  async seleccionarGrupo(grupoId) {
    const grupo = this.state.grupos.find((g) => g._id === grupoId);
    this.setState({ grupoActivo: grupo, loading: true, busquedaSubGrupo: "" });

    try {
      const res = await axios.post(
        "permisos/obtenerDetalleGrupo",
        { grupoId },
        { headers: this.props.headersToken },
      );
      if (res.data.success) {
        this.setState({ subGruposActivos: res.data.subGrupos || [] });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loading: false });
    }
  }

  abrirModal = (tipo, itemId = null, extraData = {}) => {
    this.setState({
      modalVisible: true,
      tipoModal: tipo,
      itemEditandoId: itemId,
      ...extraData,
    });
  };

  cerrarModal = () => {
    this.setState({
      modalVisible: false,
      itemEditandoId: null,
      subGrupoDestinoId: null,
    });
  };

  handleModalSuccess = () => {
    this.cerrarModal();
    if (this.state.tipoModal === "grupo") {
      this.consultarGrupos();
    } else if (this.state.grupoActivo) {
      this.seleccionarGrupo(this.state.grupoActivo._id);
    }
  };

  abrirModalEliminar = (tipo, itemId) => {
    this.setState({
      modalEliminarVisible: true,
      tipoEliminar: tipo,
      itemEliminarId: itemId,
    });
  };

  cerrarModalEliminar = () => {
    this.setState({ modalEliminarVisible: false, itemEliminarId: null });
  };

  handleEliminarSuccess = (tipoEliminado) => {
    this.cerrarModalEliminar();

    if (tipoEliminado === "grupo") {
      this.setState({ grupoActivo: null, subGruposActivos: [] });
      this.consultarGrupos();
    } else if (this.state.grupoActivo) {
      this.seleccionarGrupo(this.state.grupoActivo._id);
    }
  };

  render() {
    const {
      grupos,
      busquedaGrupo,
      grupoActivo,
      subGruposActivos,
      busquedaSubGrupo,
      loading,
      modalVisible,
      tipoModal,
      itemEditandoId,
    } = this.state;

    // Filtros de búsqueda
    const gruposFiltrados = grupos.filter((g) =>
      g.nombre.toLowerCase().includes(busquedaGrupo.toLowerCase()),
    );
    const subGruposFiltrados = subGruposActivos.filter((sg) =>
      sg.nombre.toLowerCase().includes(busquedaSubGrupo.toLowerCase()),
    );
    return (
      <>
        <PageHeader
          title="Permisos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />

        <div
          style={{
            backgroundColor: "white",
            padding: 20,
            minHeight: "calc(100vh - 160px)",
          }}
        >
          <Spin spinning={loading}>
            <Row gutter={24}>
              {/* COLUMNA IZQUIERDA: GRUPOS */}
              <Col
                span={6}
                style={{ borderRight: "1px solid #f0f0f0", height: "100%" }}
              >
                <InputItem
                  placeholder="Buscar grupo..."
                  prefix={<SearchOutlined />}
                  style={{ marginBottom: 15 }}
                  value={busquedaGrupo}
                  onChange={(e) =>
                    this.setState({ busquedaGrupo: e.target.value })
                  }
                />
                <ButtonItem
                  verde
                  block
                  icon={<PlusOutlined />}
                  onClick={() => this.abrirModal("grupo", null)}
                >
                  Nuevo Grupo
                </ButtonItem>

                <div
                  style={{
                    height: "calc(100vh - 300px)",
                    overflowY: "auto",
                    marginBottom: 15,
                  }}
                >
                  <Menu
                    mode="inline"
                    selectedKeys={[grupoActivo ? grupoActivo._id : ""]}
                    onClick={(e) => this.seleccionarGrupo(e.key)}
                    style={{ borderRight: "none" }}
                  >
                    {gruposFiltrados.map((g) => (
                      <Menu.Item
                        key={g._id}
                        icon={<SafetyCertificateOutlined />}
                      >
                        {g.nombre +
                          " - " +
                          (g?.numero ? g.numero : "Sin número")}
                      </Menu.Item>
                    ))}
                  </Menu>
                </div>
              </Col>

              <Col span={18}>
                {grupoActivo ? (
                  <>
                    <Card
                      size="small"
                      title={
                        <h3 style={{ margin: 0 }}>{grupoActivo.nombre}</h3>
                      }
                      extra={
                        <div style={{ display: "flex", gap: "10px" }}>
                          <ButtonItem
                            icon={<EditOutlined />}
                            verde
                            onClick={() =>
                              this.abrirModal("grupo", grupoActivo._id)
                            }
                          >
                            Editar Grupo
                          </ButtonItem>
                          <Tooltip
                            title="Eliminar Sub Grupo"
                            placement="top"
                            overlayInnerStyle={{
                              fontSize: "10px",
                              padding: "1px 5px",
                              minHeight: "auto",
                            }}
                          >
                            <ButtonItem
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() =>
                                this.abrirModalEliminar(
                                  "grupo",
                                  grupoActivo._id,
                                )
                              }
                            />
                          </Tooltip>
                        </div>
                      }
                      style={{ marginBottom: 20, backgroundColor: "#fafafa" }}
                    >
                      <p style={{ margin: 0, color: "#666" }}>
                        {grupoActivo.descripcion || "Sin descripción"}
                      </p>
                      <p style={{ margin: 0, color: "#666" }}>
                        {"Número: " +
                          (grupoActivo?.numero || "Sin número de orden")}
                      </p>
                    </Card>

                    <Row justify="space-between" style={{ marginBottom: 15 }}>
                      <Col span={12}>
                        <Input
                          placeholder="Buscar sub grupo..."
                          prefix={<SearchOutlined />}
                          value={busquedaSubGrupo}
                          onChange={(e) =>
                            this.setState({ busquedaSubGrupo: e.target.value })
                          }
                        />
                      </Col>
                      <Col>
                        <ButtonItem
                          type="primary"
                          lila
                          icon={<PlusOutlined />}
                          onClick={() => this.abrirModal("subgrupo", null)}
                        >
                          Agregar Sub Grupo
                        </ButtonItem>
                      </Col>
                    </Row>

                    {subGruposFiltrados.length > 0 ? (
                      <Collapse expandIconPosition="right">
                        {subGruposFiltrados.map((sg) => (
                          <Panel
                            key={sg._id}
                            header={
                              <>
                                <strong>{sg.nombre}</strong>
                                <span>
                                  {" "}
                                  {" | " +
                                    "Número: " +
                                    (sg?.numero || "Sin número de orden")}
                                </span>
                              </>
                            }
                            extra={
                              <div onClick={(e) => e.stopPropagation()}>
                                <Tooltip
                                  title="Editar Sub Grupo"
                                  placement="top"
                                  overlayInnerStyle={{
                                    fontSize: "10px",
                                    padding: "1px 5px",
                                    minHeight: "auto",
                                  }}
                                >
                                  <ButtonItem
                                    //type="text"
                                    size="small"
                                    lila
                                    icon={<EditOutlined />}
                                    style={{ marginRight: "5px" }}
                                    onClick={() =>
                                      this.abrirModal("subgrupo", sg._id)
                                    }
                                  />
                                </Tooltip>
                                <Tooltip
                                  title="Eliminar Sub Grupo"
                                  placement="top"
                                  overlayInnerStyle={{
                                    fontSize: "10px",
                                    padding: "1px 5px",
                                    minHeight: "auto",
                                  }}
                                >
                                  <ButtonItem
                                    size="small"
                                    danger
                                    icon={<DeleteOutlined />}
                                    style={{ marginRight: "5px" }}
                                    onClick={() =>
                                      this.abrirModalEliminar(
                                        "subgrupo",
                                        sg._id,
                                      )
                                    }
                                  />
                                </Tooltip>
                                <Tooltip
                                  title="Agregar Permiso al Sub Grupo"
                                  placement="top"
                                  overlayInnerStyle={{
                                    fontSize: "10px",
                                    padding: "1px 5px",
                                    minHeight: "auto",
                                  }}
                                >
                                  <ButtonItem
                                    size="small"
                                    turquesa
                                    icon={<PlusOutlined />}
                                    onClick={() =>
                                      this.abrirModal("permiso", null, {
                                        subGrupoDestinoId: sg._id,
                                      })
                                    }
                                  >
                                    Permiso
                                  </ButtonItem>
                                </Tooltip>
                              </div>
                            }
                          >
                            <p style={{ color: "#888", marginBottom: 15 }}>
                              {sg.descripcion}
                            </p>

                            {/* Permisos del Subgrupo */}
                            <List
                              size="small"
                              dataSource={sg.permisos || []}
                              renderItem={(p) => (
                                <List.Item
                                  actions={[
                                    <ButtonItem
                                      size="small"
                                      turquesa
                                      icon={<EditOutlined />}
                                      onClick={() =>
                                        this.abrirModal("permiso", p._id, {
                                          subGrupoDestinoId: sg._id,
                                        })
                                      }
                                    />,
                                    <ButtonItem
                                      size="small"
                                      danger
                                      icon={<DeleteOutlined />}
                                      onClick={() =>
                                        this.abrirModalEliminar(
                                          "permiso",
                                          p._id,
                                        )
                                      }
                                    />,
                                  ]}
                                >
                                  <List.Item.Meta
                                    title={
                                      <span>
                                        <strong>{p.nombre}</strong>
                                        <Tag
                                          color={
                                            (TIPO_TAG[p.tipo] || TIPO_TAG.boolean)
                                              .color
                                          }
                                          style={{ marginLeft: 8 }}
                                        >
                                          {
                                            (TIPO_TAG[p.tipo] || TIPO_TAG.boolean)
                                              .label
                                          }
                                        </Tag>
                                        {p.tipo === "seleccion" &&
                                        p.fuenteOpciones?.coleccion ? (
                                          <Tag color="geekblue">
                                            {labelDesdeFuenteOpciones(
                                              p.fuenteOpciones
                                            )}
                                          </Tag>
                                        ) : null}
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            color: "#979797",
                                            fontFamily: "monospace",
                                            marginLeft: 8,
                                          }}
                                        >
                                          | ID: {p._id}
                                        </span>
                                      </span>
                                    }
                                    description={
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "2px",
                                          marginTop: "4px",
                                        }}
                                      >
                                        <span style={{ color: "#252525" }}>
                                          {p.descripcion || "Sin descripción"}
                                        </span>
                                        <span
                                          style={{
                                            color: "#3b3b3b",
                                            fontSize: "14px",
                                          }}
                                        >
                                          Número:{" "}
                                          {p.numero !== undefined
                                            ? p.numero
                                            : "S/N"}
                                        </span>
                                      </div>
                                    }
                                  />
                                </List.Item>
                              )}
                            />
                          </Panel>
                        ))}
                      </Collapse>
                    ) : (
                      <Empty description="No hay subgrupos en este grupo" />
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Empty description="Selecciona un grupo del menú izquierdo" />
                  </div>
                )}
              </Col>
            </Row>
          </Spin>
        </div>
        <ModalPermisos
          visible={modalVisible}
          tipoModal={tipoModal}
          itemEditandoId={itemEditandoId}
          grupoActivoId={grupoActivo ? grupoActivo._id : null}
          subGrupoDestinoId={this.state.subGrupoDestinoId}
          onCancel={this.cerrarModal}
          onSuccess={this.handleModalSuccess}
          headersToken={this.props.headersToken}
        />
        <ModalEliminar 
          visible={this.state.modalEliminarVisible}
          tipoEliminar={this.state.tipoEliminar}
          itemEliminarId={this.state.itemEliminarId}
          onCancel={this.cerrarModalEliminar}
          onSuccess={this.handleEliminarSuccess}
          headersToken={this.props.headersToken}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(Permisos);
